import React from 'react';
import { connect } from 'react-redux';
import styled from "styled-components";

const PrivacyPolicyWrapper = styled.div`

    padding-left: 30px;
    margin-right: auto;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {

    a {
      text-decoration: none !important;
      font-size: 12px;
      color: #0F0538;
      font-family: Lato;
      font-size: 12px;
      font-weight: 500;
    }
  }
`;

function PrivacyPolicy({privacyPolicyUrl}) {
  return (
    <>
      {
        privacyPolicyUrl ? (
          <PrivacyPolicyWrapper>
            <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </PrivacyPolicyWrapper>
        ) : null
      }
    </>
)
}

const mapStateToProps = (state) => ({
  privacyPolicyUrl: state.settings.privacyPolicyUrl
});


export default connect(mapStateToProps)(PrivacyPolicy);
